import React, { useState } from "react";
import { Slide, Fade } from "react-awesome-reveal";

export const ExpandButton = ({ onExapnd }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = () => {
    setIsExpanded(!isExpanded);
    onExapnd?.();
  };
  return (
    <>
      <div
        className="flex justify-center space-x-2 py-[18px] items-center cursor-pointer"
        onClick={handleClick}
      >
        {/* <img src="/voter/Dropdown_arrow.png" alt="My Example" /> */}
        <i
          className={`fa ${isExpanded ? "fa-chevron-up" : "fa-chevron-down"} text-xs`}
        />
        <span className="font-normal text-[14px] leading-[16px] text-[#1B1B1D]">
          {isExpanded ? "Collapse" : "Family Members"}
        </span>
      </div>
    </>
  );
};
